/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const ProductCompareService = require('./productCompareService');
const commonModule = require('../common/commonModule');
const cookiesModule = require('../cookies/cookiesModule');
const swiftypeModule = require('../swiftype/swiftypeModule');

const productCompareModule = angular
    .module('enervee_utils.compare', [
        commonModule.name,
        cookiesModule.name,
        swiftypeModule.name,
    ])
    .factory('ProductCompareService', ProductCompareService);

module.exports = productCompareModule;